import { MatConfirmDialogComponent } from '../../shared/component/mat-confirm-dialog/mat-confirm-dialog.component';
import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { CustomCategoryComponent } from 'src/app/shared/component/custom-category/custom-category.component';
@Injectable({
  providedIn: 'root'
})
export class DialogService {

  constructor(
    private md: MatDialog
  ) { }

  openConfirmDialog(msg1: string, msg2: string, hideButtons: boolean = false){
    return this.md.open(MatConfirmDialogComponent, {
      width: '350px',
      disableClose: true,
      data: {
        message1: msg1,
        message2: msg2,
        hideButtons
      }
    });
  }

  openAddCategoryDialog(): MatDialogRef<CustomCategoryComponent> {
    const dialogRef = this.md.open(CustomCategoryComponent, {
      width: '1500px',
      maxWidth: 'none',
      panelClass: 'wide-dialog',
      disableClose: false // Allow closing with ESC or backdrop click
    });
    
    return dialogRef; // ✅ Return the dialog reference
  }
}
